import type { OrganizationBillingContext } from '@fluenceur/types';

type ShopifyFreeApproval = NonNullable<OrganizationBillingContext['shopifyFreeApproval']>;

/**
 * Where the Shopify approval of the Free plan stands, as the one short line the
 * plan choice footer shows beside its action. Every state keeps its own words:
 * a member who cannot approve, a refusal or an expiry is never left silent.
 */
export function shopifyFreeApprovalStatus(
  approval: ShopifyFreeApproval,
  receiptPending = false
): { key: string; warning: boolean } {
  if (!approval.canApprove) return { key: 'shopifyFreeApproval.memberBody', warning: false };
  if (approval.status === 'declined')
    return { key: 'shopifyFreeApproval.status.declined', warning: true };
  if (approval.status === 'expired')
    return { key: 'shopifyFreeApproval.status.expired', warning: true };
  if (
    receiptPending ||
    approval.status === 'uncertain' ||
    approval.status === 'processing' ||
    approval.status === 'reserved'
  )
    return {
      key: 'shopifyFreeApproval.status.checking',
      warning: approval.status === 'uncertain',
    };
  if (approval.requirement === 'pending')
    return { key: 'shopifyFreeApproval.status.pending', warning: false };
  return { key: 'shopifyFreeApproval.summary', warning: false };
}

/** Checking an approval already given in Shopify needs a known operation or a receipt. */
export const canCheckShopifyFreeApproval = (
  approval: ShopifyFreeApproval,
  receiptPending = false
) => approval.canApprove && (!!approval.operationId || receiptPending);
